import Link from "next/link";
import { UrlObject } from "url";
import { HStack, Stack } from "@chakra-ui/react";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { Text } from "@/elements";
import { ListWithLabel, ListWithLabelProps } from "../list";

type ContentProps = {
  text?: string;
  link?: string | UrlObject;
} & ListWithLabelProps;

export const ContentWithLabelList = (props: ContentProps) => {
  const { text, link, points, separator } = props;
  const textVariant = "body2";

  return (
    <Stack height={"100%"} justifyContent={"space-between"} gap={4}>
      {text && (
        <Text color={"text.100"} variant={textVariant} whiteSpace={"pre-line"}>
          {text}
        </Text>
      )}
      {points && <ListWithLabel points={points} separator={separator} />}
      {link && (
        <Link href={link} target="_blank">
          <HStack gap={1}>
            <Text
              color="primary.200"
              fontWeight={600}
              variant={textVariant}
              _hover={{ color: "primary.200", textDecoration: "underline" }}
            >
              Explore more
            </Text>
            <FiArrowUpRight fontSize="24px" />
          </HStack>
        </Link>
      )}
    </Stack>
  );
};
